module.exports = __webpack_public_path__ + "static/media/dark-theme-milage.ab3340ba.svg";